import Button from 'components/Button'
import { ArrowDownIcon } from 'components/Icon/icons/arrow-down'
import Text from 'components/Text'
import { View } from 'components/View'
import React from 'react'

/**
 * @param props
 * @param props.label
 * @param props.onClick
 * @param props.iconHidden
 * @return {Element}
 * @constructor
 */
export default function FilterChip (props) {
  const {
    label,
    onClick,
    iconHidden
  } = props

  return (
    <Button
      style={{
        width: 'unset',
        maxWidth: 'unset',
        height: 'unset',
        border: '1px solid #c8c6c6',
        padding: '5px 15px',
        borderRadius: '15px',
        marginRight: '10px',
        marginBottom: '10px',
        background: iconHidden && '#f6f6f6'
      }}
      onClick={onClick}
    >
      <View
        row
        ac
      >
        <Text
          mr={!iconHidden}
          fs='12px'
          c='#000000'
        >{label}
        </Text>
        {!iconHidden && (
          <ArrowDownIcon
            style={{
              width: '12px',
              height: '12px',
              paddingTop: '2px'
            }}
          />
        )}
      </View>
    </Button>
  )
}
